import React from 'react'

import { FormattedMessage } from 'react-intl'

import AnalyticsAudienceReporting from '@components/Analytics/AudienceReporting/AudienceReporting'
import { NoticeUnsupportedScreen } from '@components/UI/Notice'
import { SupportedScreenWrapper } from '@components/UI/ScreenSize'

const AnalyticsAudienceReportingWrapper: React.FC = () => {
  return (
    <React.Fragment>
      <NoticeUnsupportedScreen
        alt="audience-reporting-unsupported-screen"
        title={<FormattedMessage id="analytics.audienceReporting.unsupportedScreen.title" />}
        subtitle={<FormattedMessage id="analytics.audienceReporting.unsupportedScreen.subtitle" />}
      />
      <SupportedScreenWrapper>
        <AnalyticsAudienceReporting />
      </SupportedScreenWrapper>
    </React.Fragment>
  )
}

export default AnalyticsAudienceReportingWrapper
